export default __webpack_public_path__ + "8436f44cf9f8746207369fd9b6d0bfa7.svg";